/* unplugin-vue-components disabled */import script from "./ch3.vue?vue&type=script&setup=true&lang=ts"
export * from "./ch3.vue?vue&type=script&setup=true&lang=ts"

import "./ch3.vue?vue&type=style&index=0&id=5b3ce2bc&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b3ce2bc"]])

export default __exports__